import URL from '../api_url';

export const EVALUATION_API = `${URL}/evaluation`;

export const EVALUATIONS_API = `${URL}/evaluations`;
